<template>
  <div class="serveBrief">
    <section id="wrap">
      <div class="server-header">
        <img src="../../../assets/images/header-bg.png" alt="标题" />
        <template v-if="zhoren!='zh'&&zhoren != 'en' ">
            <div class="ser-title">
              {{$t('ser_inc')}}
            </div>
        </template>
      </div>
      <div class="server-content text-center">
        <ul class="tab-header-list">
          <li @click="currentTabIdx=idx" style="margin-right:0;" :class="[idx==currentTabIdx?'active':'']" v-for="(item,idx) in tabHeaderList" :key="idx">{{$t(item)}}</li>
        </ul>
        
        <ul class="tab-content-list">
          <transition name="ani" mode="out-in">
          <li :key="0" v-if="currentTabIdx==0">
           
            <div class="img-box">
              <img
                src="../../../../public/report/report1.png"
              />
              <p>
                <a :href="require('../../../../public/report/report1.png')" target="_blank" class="href">{{$t('serveBrief_tab1_ckyt')}}</a>
                <a href="http://www.inspector.ltd/api/com/download?file[0]=http://www.inspector.ltd/report1-file.pdf" target="_blank"  download class="download">{{$t('serveBrief_tab1_xzai')}}</a>
              </p>
            </div>
            <div class="text-box">
              <h4>
                <span>{{$t('serveBrief_tab1_title')}}</span>
                <span class="money">US$ {{YHMoney[yhFeeType[0]]}} {{$t('user_Index_RT')}}</span>
              </h4>
              <p
                class="brief"
              >{{$t('serveBrief_tab1_msg1')}}</p>
              <h5>{{$t('serveBrief_tab1_jyyd')}}</h5>
              <ul class="badge-list">
                <li>{{$t('serveBrief_tab1_item1')}}</li>
                 <li>{{$t('serveBrief_tab1_item9')}}</li>
                <li>{{$t('serveBrief_tab1_item2')}}</li>
                <li>{{$t('serveBrief_tab1_item3')}}</li>
                <li>{{$t('serveBrief_tab1_item4')}}</li>
                <li>{{$t('serveBrief_tab1_item5')}}</li>
                <li>{{$t('serveBrief_tab1_item6')}}</li>
                <li>{{$t('serveBrief_tab1_item7')}}</li>
                <li>{{$t('serveBrief_tab1_item8')}}</li>
               
              </ul>
              <el-button type="primary" class="order-btn" v-if="role != 2" @click="openWantOrder(1)">{{$t("serveBrief_tab1_btn")}}</el-button>
            </div>
          </li>

          <li :key="1" v-if="currentTabIdx==1">
            <div class="img-box">
              <img
                src="../../../../public/report/report2.png"
              />
              <p>
                <a :href="require('../../../../public/report/report2.png')" target="_blank" class="href">{{$t('serveBrief_tab1_ckyt')}}</a>
                <a href="http://www.inspector.ltd/api/com/download?file[0]=http://www.inspector.ltd/report2-file.pdf"  target="_blank" class="download" download>{{$t('serveBrief_tab1_xzai')}}</a>
              </p>
            </div>
            <div class="text-box">
              <h4>
                <span>{{$t("serveBrief_tab2_title")}}</span>
                <span class="money">US$ {{YHMoney[yhFeeType[1]]}} {{$t('user_Index_RT')}}</span>
              </h4>
              <p
                class="brief"
              >{{$t("serveBrief_tab2_msg1")}}</p>
              <h5>{{$t("serveBrief_tab2_jyyd")}}</h5>
              <ul class="badge-list">
                <li>{{$t("serveBrief_tab2_item1")}}</li>
                <li>{{$t("serveBrief_tab2_item2")}}</li>
                <li>{{$t("serveBrief_tab2_item3")}}</li>
                <li>{{$t("serveBrief_tab2_item4")}}</li>
                <li>{{$t("serveBrief_tab2_item5")}}</li>
                <li>{{$t("serveBrief_tab2_item6")}}</li>
                <li>{{$t("serveBrief_tab2_item7")}}</li>
                <li>{{$t("serveBrief_tab2_item8")}}</li>
                <li>{{$t("serveBrief_tab2_item9")}}</li>
              </ul>
              <el-button type="primary" class="order-btn" v-if="role != 2" @click="openWantOrder(2)">{{$t("serveBrief_tab1_btn")}}</el-button>
            </div>
          </li>


          <li :key="2" v-if="currentTabIdx==2">
            <div class="img-box">
              <img
                src="../../../../public/report/report3.png"
              />
              <p>
                <a :href="require('../../../../public/report/report3.png')" target="_blank" class="href">{{$t('serveBrief_tab1_ckyt')}}</a>
                <a  href="http://www.inspector.ltd/api/com/download?file[0]=http://www.inspector.ltd/report3-file.pdf" target="_blank" download class="download">{{$t('serveBrief_tab1_xzai')}}</a>
              </p>
            </div>
            <div class="text-box">
              <h4>
                <span>{{$t('serveBrief_tab3_title')}}</span>
                <span class="money">US$ {{YHMoney[yhFeeType[2]]}} {{$t('user_Index_RT')}}</span>
              </h4>
              <p
                class="brief"
              >{{$t('serveBrief_tab3_msg1')}}</p>
              <h5>{{$t('serveBrief_tab3_jyyd')}}</h5>
              <ul class="badge-list">
                <li>{{$t('serveBrief_tab3_item1')}}</li>
                <li>{{$t('serveBrief_tab3_item2')}}</li>
                <li>{{$t('serveBrief_tab3_item3')}}</li>
                <li>{{$t('serveBrief_tab3_item4')}}</li>
                <li>{{$t('serveBrief_tab3_item5')}}</li>
                <li>{{$t('serveBrief_tab3_item6')}}</li>
      
              </ul>
              <el-button type="primary" class="order-btn" v-if="role != 2" @click="openWantOrder(3)">{{$t('serveBrief_tab1_btn')}}</el-button>
            </div>
          </li>

          <li  :key="3" v-if="currentTabIdx==3">
            <div class="img-box">
              <img
                src="../../../../public/report/report6.png"
              />
              <p>
                <a :href="require('../../../../public/report/report6.png')" target="_blank" class="href">{{$t('serveBrief_tab1_ckyt')}}</a>
                <a href="http://www.inspector.ltd/api/com/download?file[0]=http://www.inspector.ltd/report6-file.xls" download target="_blank" class="download">{{$t('serveBrief_tab1_xzai')}}</a>
              </p>
            </div>
            <div class="text-box">
              <h4>
                <span>{{$t('serveBrief_tab4_title')}}</span>
                <span class="money">US$ {{YHMoney[yhFeeType[3]]}} {{$t('user_Index_RT')}}</span>
              </h4>
              <p
                class="brief"
              >{{$t('serveBrief_tab4_msg1')}}</p>
              <h5>{{$t('serveBrief_tab4_sjlr')}}</h5>
              <ul class="badge-list">
                <li>{{$t('serveBrief_tab4_item1')}}</li>
                <li>{{$t('serveBrief_tab4_item2')}}</li>
                <li>{{$t('serveBrief_tab4_item3')}}</li>
                <li>{{$t('serveBrief_tab4_item4')}}</li>
                <li>{{$t('serveBrief_tab4_item5')}}</li>
                <li>{{$t('serveBrief_tab4_item6')}}</li>
                <li>{{$t('serveBrief_tab4_item7')}}</li>
          
              </ul>
               <h5>{{$t('serveBrief_tab4_zhpj')}}</h5>
              <ul class="badge-list">
                <li style="width:100%">{{$t('serveBrief_tab4_item8')}}</li>
              </ul>

              <el-button type="primary" class="order-btn" v-if="role != 2" @click="openWantOrder(4)">{{$t('serveBrief_tab1_btn')}}</el-button>
            </div>
          </li>

          <li :key="4" v-if="currentTabIdx==4">
            <div class="img-box">
              <img
                src="../../../../public/report/report4.png"
              />
              <p>
                <a :href="require('../../../../public/report/report4.png')" target="_blank" class="href">{{$t('serveBrief_tab1_ckyt')}}</a>
                <a href="http://www.inspector.ltd/api/com/download?file[0]=http://www.inspector.ltd/report4-file.pdf" download target="_blank" class="download">{{$t('serveBrief_tab1_xzai')}}</a>
              </p>
            </div>
            <div class="text-box">
              <h4>
                <span>{{$t('serveBrief_tab5_title')}}</span>
                <span class="money">US$ {{YHMoney[yhFeeType[4]]}} {{$t('user_Index_RT')}}</span>
              </h4>
              <p
                class="brief"
              >{{$t('serveBrief_tab5_msg1')}}</p>
              <h5>{{$t('serveBrief_tab5_jyyd')}}</h5>
              <ul class="badge-list" >
                <li style="width:100%">{{$t('serveBrief_tab5_item1')}}</li>
                <li style="width:100%">{{$t('serveBrief_tab5_item2')}}</li>
                <li style="width:100%">{{$t('serveBrief_tab5_item3')}}</li>
                <li style="width:100%">{{$t('serveBrief_tab5_item4')}}</li>
                <li style="width:100%">{{$t('serveBrief_tab5_item5')}}</li>
          
              </ul>
              <el-button type="primary" class="order-btn" v-if="role != 2" @click="openWantOrder(5)">{{$t('serveBrief_tab1_btn')}}</el-button>
            </div>
          </li>

          <li :key="5" v-if="currentTabIdx==5">
            <div class="img-box">
              <img
                src="../../../../public/report/report5.png"
              />
              <p>
                <a :href="require('../../../../public/report/report5.png')" target="_blank" class="href">{{$t('serveBrief_tab1_ckyt')}}</a>
                <a href="http://www.inspector.ltd/api/com/download?file[0]=http://www.inspector.ltd/report5-file.pdf" download target="_blank" class="download">{{$t('serveBrief_tab1_xzai')}}</a>
              </p>
            </div>
            <div class="text-box">
              <h4>
                <span>{{$t('serveBrief_tab6_title')}}</span>
                <span class="money">US$ {{YHMoney[yhFeeType[5]]}} {{$t('user_Index_RT')}}</span>
              </h4>
              <p
                class="brief"
              >{{$t('serveBrief_tab6_msg1')}}</p>
              <h5>{{$t('serveBrief_tab6_jyyd')}}</h5>
              <ul class="badge-list">
                <li style="width:100%">{{$t('serveBrief_tab6_item1')}}</li>        
                <li style="width:100%">{{$t('serveBrief_tab6_item2')}}</li>
                <li style="width:100%">{{$t('serveBrief_tab6_item3')}}</li>
                <li style="width:100%">{{$t('serveBrief_tab6_item4')}}</li>
                <li style="width:100%">{{$t('serveBrief_tab6_item5')}}</li>
              </ul>
              <el-button type="primary" class="order-btn" v-if="role != 2" @click="openWantOrder(6)">{{$t('serveBrief_tab1_btn')}}</el-button>
            </div>
          </li>

        </transition>

        </ul>
      </div>
    </section>
  </div>
</template>
    
<script>
import { getInspection } from "@/api/znOrder";
export default {
  name: "serveBrief",
  data() {
    return {
       currentTabIdx:0,
       YHMoney:{},
       yhFeeType:[
        "us_insp_fee", // 抽检
        "full_fee", // 全检
        "line_insp_fee",//在线
        "fac_insp_fee", // 验厂
        "sup_insp_fee", // 监装
        "and_insp_fee"//验货+监装
      ],
      zhoren: localStorage.getItem("locale") || "zh",
       tabHeaderList:["Home_index_cyjy","Home_index_qsjy","user_Index_ZXJY","Home_index_gcsh","Home_index_jz","Home_index_jzAndyh"]
    };
  },
  computed: {
    role(){
      return localStorage.getItem('role')
    }
  },
  methods:{
    openWantOrder(val){
      let routeUrl = this.$router.resolve({
        path:'/index/wantOrder',
        query:{selType:val}
      });
      window.open(routeUrl.href,'_blank')
    },
    async getInspection(){
      const res = await getInspection();
      const {code,data} = res.data

      if(code == 200){
        this.YHMoney = data
      }
    }
  },
  created(){
    this.currentTabIdx = this.$route.query.index || 0
   this.getInspection()
  }
};
</script>
<style scoped lang="scss">
.ani-enter,.ani-leave-to{
   opacity: 0;
}
.ani-enter-to,.ani-leave{
  opacity: 1;
}
.ani-enter-active,.ani-leave-acitve{
  transition: all 1s;
}
#wrap {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 40px;
  .server-header {
    width: 100%;
    position:relative;
    margin: 0px auto 0;
    & > img {
      display: block;
      width: 100%;
      margin: 0 auto;
      user-select: none;
    }
    .ser-title{
      position:absolute;
      text-align:center;
      bottom:46px;
      width:100%;
      font-size:18px;
      color:#696868;
      background:#fff;
    }
  }

  .server-content {
    .tab-header-list {
      display: inline-block;
      li {
        padding: 5px 16px;
        display: inline-block;
        cursor: pointer;
        &:not(:last-child) {
          margin-right: 30px;
        }
        &.active {
          border-radius: 4px;
          background-color: rgb(245, 104, 0);
          color: #fff;
        }
      }
    }
    .tab-content-list {
      margin-top: 35px;
      & > li {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      }
      .img-box {
        flex: 0 0 280px;
        border: 2px solid #888;
        box-sizing: border-box;
        padding: 15px;
        text-align: right;
        .download,
        .href {
          color: #3333cc;
          margin-right: 20px;
          font-size: 15px;
          line-height: 2;
        }
        & > img {
          display: block;
          max-width: 100%;
          margin:0 auto;
        }
      }
      .text-box {
        flex: 1;
        box-sizing: border-box;
        padding: 20px 40px;
        text-align: left;
        h4 {
          font-family: "Arial Negreta", "Arial Normal", "Arial";
          font-weight: 700;
          font-style: normal;
          font-size: 20px;
          vertical-align: middle;
          margin-bottom: 20px;
          .money {
            color: #d05800;
            font-weight: normal;
            margin-left: 30px;
          }
        }
        .brief {
          font-size: 16px;
          color: #666666;
          line-height: 28px;
        }
        h5 {
          font-family: "Arial Negreta", "Arial Normal", "Arial";
          font-weight: 700;
          font-style: normal;
          font-size: 16px;
          margin-top: 20px;
          margin-bottom: 20px;
        }
        .badge-list {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          li {
            width: 33.333333%;
            padding-left: 30px;
            box-sizing: border-box;
            position: relative;
            font-size: 16px;
            color: #666666;
            line-height: 28px;
            &::before {
              content: "";
              display: block;
              position: absolute;
              left: 0;
              top: 0;
              width: 21px;
              height: 100%;
              background: url("../../../assets/images/u262.png") no-repeat;
              background-size: 21px 24px;
              background-position: center center;
            }
          }
        }
        .order-btn{
          display: block;
          margin: 88px auto 0;
        }
      }
    }
  }
}
</style>